import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9d48cede"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "50vw"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "18px",
    "font-weight": "blod",
    "margin-bottom": "50px",
    "width": "75%",
    "margin-left": "99px",
    "word-wrap": "break-word"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "text-align": "center",
    "font-size": "18px",
    "font-weight": "blod",
    "margin-bottom": "50px",
    "width": "75%",
    "margin-left": "99px",
    "word-wrap": "break-word"
  }
};
const _hoisted_4 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "line-height": "20px",
    "min-width": "60px"
  }
}, /*#__PURE__*/_toDisplayString('问题现象') + "： ", -1));

const _hoisted_6 = {
  style: {
    "color": "rgb(126, 127, 134)",
    "line-height": "20px",
    "word-break": "break-all",
    "margin-right": "30px"
  }
};
const _hoisted_7 = {
  key: 3
};
const _hoisted_8 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto",
    "margin-bottom": "15px"
  }
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "color": "rgb(217,0,27)",
    "font-weight": "bold",
    "font-size": "15px"
  }
}, " 基础信息 ", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "text-align": "center"
  }
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_13 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {}
}, " 产品购买渠道: ", -1));

const _hoisted_15 = {
  class: "item content"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "text-align": "center"
  }
}, null, -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {}
}, " 订单编号: ", -1));

const _hoisted_22 = {
  class: "item content"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "text-align": "center"
  }
}, " 发货仓库: ", -1));

const _hoisted_24 = {
  class: "item content"
};
const _hoisted_25 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {}
}, " 付款时间: ", -1));

const _hoisted_27 = {
  class: "item content"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "text-align": "center"
  }
}, " 质保情况: ", -1));

const _hoisted_29 = {
  class: "item content"
};
const _hoisted_30 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {}
}, " 商品品名: ", -1));

const _hoisted_32 = {
  class: "item content"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "text-align": "center"
  }
}, null, -1));

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));

const _hoisted_36 = {
  style: {
    "margin": "20px 50px",
    "font-weight": "bold",
    "font-size": "15px"
  },
  ref: "dptEdit"
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_39 = {
  style: {
    "width": "90%"
  }
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "30px"
  }
}, " 审核结论 ", -1));

const _hoisted_41 = {
  style: {
    "display": "flex"
  }
};

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "20px"
  }
}, " 处理方案: ", -1));

const _hoisted_43 = {
  key: 0,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_44 = {
  key: 1,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_45 = {
  key: 1
};
const _hoisted_46 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_47 = {
  style: {
    "width": "90%"
  }
};

const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "30px"
  }
}, " 作废 ", -1));

const _hoisted_49 = {
  style: {
    "display": "flex"
  }
};

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "20px"
  }
}, " 作废原因: ", -1));

const _hoisted_51 = {
  class: "content",
  style: {
    "margin-left": "5%",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_52 = {
  key: 2,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
};

const _hoisted_53 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_54 = /*#__PURE__*/_createTextVNode("上一步");

const _hoisted_55 = /*#__PURE__*/_createTextVNode("发送用户填报");

const _hoisted_56 = {
  key: 3,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
};

const _hoisted_57 = /*#__PURE__*/_createTextVNode("返回");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon_Close = _resolveComponent("el-icon-Close");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_templateInit = _resolveComponent("templateInit");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_tabs = _resolveComponent("el-tabs");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "width": "50vw"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_el_tabs, {
        type: "border-card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 20,
          style: {
            "cursor": "pointer",
            "float": "right"
          },
          onClick: this.close
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon_Close)]),
          _: 1
        }, 8, ["onClick"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [$props.dpt.orderNum ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 查看-" + _toDisplayString($props.dpt.tempItemName) + "-" + _toDisplayString($options.getTextByStatus($props.dpt.status)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.dpt.tempName), 1)), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString($props.dpt.problemPhenomenon || '--'), 1)]), $props.dpt.status ? (_openBlock(), _createBlock(_component_el_divider, {
          key: 2
        })) : _createCommentVNode("", true), $props.dpt.status ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", {
          class: "item",
          style: {
            "font-weight": "bold",
            "font-size": "15px",
            "cursor": "pointer"
          },
          onClick: _cache[0] || (_cache[0] = (...args) => $options.teleport && $options.teleport(...args))
        }, " 报损单填报项 "), _hoisted_10, _hoisted_11, _hoisted_12]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString($props.dpt.purchasingChannelsName), 1), _hoisted_16, _hoisted_17, _hoisted_18]), $props.dpt.purchasingChannels === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString($props.dpt.orderNum), 1), _hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString($props.dpt.deliveryWarehouseName), 1)]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString($props.dpt.paymentTime), 1), _hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString($props.dpt.warrantyTypeName), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString($props.dpt.shopName || '--'), 1), _hoisted_33, _hoisted_34, _hoisted_35])])) : _createCommentVNode("", true)]), _createVNode(_component_el_divider), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_36, " 报损单填报项 ", 512)]), _createVNode(_component_templateInit, {
          tempItemContentList: $props.dpt.tempItemContentList,
          languageType: $props.dpt.languageType,
          status: $props.dpt.status,
          isAdmin: true,
          isView: true,
          sortTemplateData: $options.sortTemplateData
        }, null, 8, ["tempItemContentList", "languageType", "status", "sortTemplateData"]), this.dpt.status === '3' || this.dpt.status === '4' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_hoisted_42, $props.dpt.checkConclusionStatus === '6' ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString($props.dpt.checkConclusionRemark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString($props.dpt.checkConclusionStatusName), 1))])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true), this.dpt.status === '5' ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, _toDisplayString($props.dpt.abandonCause), 1)])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true), !$props.dpt.status ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(_component_el_button, {
          style: {
            "width": "80px",
            "background-color": "rgba(255, 245,245)",
            "border": "1px solid rgba(210,0,47)",
            "color": "rgba(210,0,47)"
          },
          onClick: $options.cancel
        }, {
          default: _withCtx(() => [_hoisted_53]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "width": "80px",
            "margin-left": "30px",
            "background-color": "rgba(255, 245,245)",
            "border": "1px solid rgba(210,0,47)",
            "color": "rgba(210,0,47)"
          },
          onClick: $options.preStep
        }, {
          default: _withCtx(() => [_hoisted_54]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "width": "120px",
            "margin-left": "30px",
            "background-color": "rgba(210,0,47)",
            "color": "white",
            "border": "none"
          },
          onClick: $options.nextStep
        }, {
          default: _withCtx(() => [_hoisted_55]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true), $props.dpt.status ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_el_button, {
          style: {
            "width": "100px",
            "margin-left": "30px",
            "background-color": "rgba(210,0,47)",
            "color": "white"
          },
          onClick: $options.returnPreView
        }, {
          default: _withCtx(() => [_hoisted_57]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true)])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}